import * as Yup from "yup";

const minConditionWithTrim = (value, min) => value && value.trim().length >= min;
export const userValidation = (t) =>
    Yup.object({
        email: Yup.string()
            .email(t("registration.invalidEmail"))
            .max(32, `${t("registration.maxLength")}32`)
            .required(t("registration.required")),
        password: Yup.string()
            .test("trim", t("registration.passwordLength"), (value) => minConditionWithTrim(value, 8))
            .max(255)
            .required(t("registration.required")),
        rePassword: Yup.string()
            .oneOf([Yup.ref("password"), null], t("registration.notMatch"))
            .required(t("registration.required")),
        phone: Yup.string()
            .test("trim",  `${t("registration.minLength")}5`, (value) => minConditionWithTrim(value, 5))
            .max(15, `${t("registration.maxLength")}15`)
            .required(t("registration.required")),
        lastname: Yup.string()
            .test("trim",  `${t("registration.minLength")}2`, (value) => minConditionWithTrim(value, 2))
            .max(32, `${t("registration.maxLength")}32`)
            .required(t("registration.required")),
        firstname: Yup.string()
            .max(32, `${t("registration.maxLength")}32`)
            .test("trim",  `${t("registration.minLength")}2`, (value) => minConditionWithTrim(value, 2))
            .required(t("registration.required")),
    });

export const companyValidation = (t) =>
    Yup.object({
        name: Yup.string()
            .test("trim",  `${t("registration.minLength")}3`, (value) => minConditionWithTrim(value, 3))
            .max(64, `${t("registration.maxLength")}64`)
            .required(t("registration.required")),
        legal_address: Yup.string().max(128, `${t("registration.maxLength")}128`),
        post_address: Yup.string().max(128, `${t("registration.maxLength")}128`),
        payer_number: Yup.string()
            .matches(/^\d+$/, t("registration.onlyDigits"))
            .required(t("registration.required")),
        company_roles_ids: Yup.array()
            .of(Yup.string())
            .min(1, t("registration.requiredRole"))
            .required(t("registration.requiredRole")),
    });

export const codeValidation = (t) =>
    Yup.object({
        code: Yup.string().required(t("registration.required")),
    });
